import React from 'react';
import { History } from 'history';
import { Input, InputDate, InputMultiline, InputSelect, Layout, InputFile, InputPicklist, InputSwitch, InputUID } from '../../components';
import BaseView from '../base/base-view.component'; 
import Model from './event-model';  //editable..
import SectionChecklist from '../section/section-checklist.component';
import PersonalinfoChecklist from '../personalinfo/personalinfo-checklist.component';
import EventList from './event-list.component';
import EventquizList from '../eventquiz/eventquiz-list.component';
import ReportList from '../report/report-list.component';
import AppService from '../../services/app.service';
import QuizresultList from '../quizresult/quizresult-list.component';

interface IProps { 
    history: History;
    root?: string;
    caption?: string;
    astemplate?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class EventView extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }
    
    private onLoad = (data: any) => {
        this.setState({datarow: data});
    }
    
    private onLoadC = (data: any) => {
        console.log(data)
    }

    render() {
        return(
            //editable..
            <BaseView history={this.props.history} caption={this.state.datarow.parent && 'View Section'}
                model={Model} onLoad={this.onLoad} disableCard>

                <Layout history={this.props.history} content={[
                    {caption: 'Details', child: 
                    <>
                        <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly />
                        <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                        <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                        {AppService.isAppFullVersion() &&
                        <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                        }
                        {this.state.datarow.parent &&
                        <Input name='parentCaption' label='Parent' value={this.state.datarow.parentCaption} readOnly/>
                        }
                        <InputSelect name='type' label='Type' value={this.state.datarow.type} options={Model.optionType} readOnly/>
                        <InputSelect name='viewstyle' label='View Style' value={this.state.datarow.viewstyle} options={Model.optionViewstyle}readOnly />
                        <InputSwitch name='usecamera' label='Use Camera' value={this.state.datarow.usecamera} readOnly/>
                        <InputSwitch name='extratime' label='Allow Extra Time' value={this.state.datarow.extratime} readOnly/>
                        {!this.state.datarow.parent && <>
                        <InputPicklist name='messagestart' label='Message to Send Invitation' value={this.state.datarow.messagestart} caption={this.state.datarow.messagestartCaption} readOnly/>
                        <InputPicklist name='messageend' label='Message to Send Result' value={this.state.datarow.messageend} caption={this.state.datarow.messageendCaption} readOnly/>
                        </>}
                        <InputPicklist name='section' label='Section' value='' caption={this.state.datarow.sectionCaption} readOnly={this.state.datarow.parent} disableAutoClose>
                            <SectionChecklist history={this.props.history} currentId={this.state.datarow.section} onLoad={this.onLoadC} readOnly disableBackButton/>
                        </InputPicklist>                         
                        {!this.state.datarow.parent &&
                        <InputPicklist name='customer' label='Customer' value={this.state.datarow.customer} caption={this.state.datarow.customerCaption} readOnly/>
                        }
                        <InputPicklist name='participant' label='Participant' value='' caption={this.state.datarow.participantCaption} readOnly={this.state.datarow.parent} disableAutoClose>
                            <PersonalinfoChecklist history={this.props.history} caption='Selected Participant' currentId={this.state.datarow.participant} readOnly disableBackButton/>
                        </InputPicklist>
                        <InputDate name='startdate' label='Start Date' value={this.state.datarow.startdate} readOnly/>
                        <InputDate name='enddate' label='End Date' value={this.state.datarow.enddate} readOnly/>
                        <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' readOnly/>                  
                        <InputUID name='uid' label='QR Code' value={this.state.datarow.uid} error={this.state.errors?.uid} />
                    </>
                    },

                    {caption: 'Sections', hide: this.state.datarow.eventquizLength > 0, child: 
                    this.state.datarow.id > 0 && this.props.history &&
                        <EventList history={this.props.history} root={this.props.root} caption='Section' parentId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/>
                    },

                    {caption: 'Questions', hide: this.state.datarow.eventquizLength === 0, child: 
                    this.state.datarow.id > 0 && this.props.history &&
                        <EventquizList history={this.props.history} root={this.props.root} caption='Quiz Question' eventId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/>
                    },

                    {caption: 'Summary', hide: !!this.state.datarow.parent, child:
                    this.state.datarow.id > 0 && this.props.history &&
                        <QuizresultList history={this.props.history} root={this.props.root} caption='Summary' eventName={this.state.datarow.eventParticipantCurrent?.name} actions={[]} disableBackButton disableCard/>
                    },

                    {caption: 'Results', hide: this.state.datarow.eventquizLength > 0, child:
                    this.state.datarow.id > 0 && this.props.history &&
                        <ReportList history={this.props.history} root={this.props.root} caption='Event Result' previewId={this.state.datarow.id} reportgroupId={0/*this.state.datarowEventtype.reportgroup*/} actions={['preview']} disableBackButton disableCard/>
                    },
                ]}
                />

            </BaseView>
        )
    }
}